import { createIconsConfig } from 'vuestic-ui'
import aliases from './aliases'
import TrashIcon from '@/assets/icons/trash.svg?component'
import Payout from '@/assets/icons/payout.svg?component'
import Overview from '@/assets/icons/overview.svg?component'
import Filter from '@/assets/icons/filter.svg?component'
import Lock from '@/assets/icons/lock.svg?component'
import Email from '@/assets/icons/email.svg?component'
import Pencil from '@/assets/icons/pencil.svg?component'
import CirclePlus from '@/assets/icons/circle-plus.svg?component'
import Schedule from '@/assets/icons/schedule.svg?component'
import Dashboard from '@/assets/icons/dashboard.svg?component'
import Transactions from '@/assets/icons/transactions.svg?component'
import Leads from '@/assets/icons/leads.svg?component'
import Users from '@/assets/icons/users.svg?component'
import Logs from '@/assets/icons/logs.svg?component'
import HandIcon from '@/assets/icons/hand-icon.svg?component'
import Cards from '@/assets/icons/cards.svg?component'
import ArrowUp from '@/assets/icons/arrow-up.svg?component'

const customIcons: Record<string, object> = {
  'custom-trash': TrashIcon,
  'custom-payout': Payout,
  'custom-overview': Overview,
  'custom-filter': Filter,
  'custom-lock': Lock,
  'custom-email': Email,
  'custom-pencil': Pencil,
  'custom-circle-plus': CirclePlus,
  'custom-schedule': Schedule,
  'custom-dashboard': Dashboard,
  'custom-transactions': Transactions,
  'custom-leads': Leads,
  'custom-users': Users,
  'custom-logs': Logs,
  'custom-hand-icon': HandIcon,
  'custom-cards': Cards,
  'custom-arrow-up': ArrowUp,
}
//в icon-config.ts импортируем кастомные svg иконки с папки /assets/icons/{icon}.name,
//затем в alias добавляем в конец массива
export default createIconsConfig({
  aliases,
  fonts: [
    {
      name: 'fa4-{code}',
      resolve: ({ code }) => ({ class: `fa4 fa fa-${code}` }),
    },
    {
      name: 'ion-{font}-{code}',
      resolve: ({ font, code }) => ({
        class: `icon ion-${font}-${code}`,
      }),
    },
    {
      name: 'vuestic-iconset-{code}',
      resolve: ({ code }) => ({ class: `vuestic-iconset vuestic-iconset-${code}` }),
    },
    {
      name: 'flag-icon-{code} {size}',
      resolve: ({ code, size }) => ({ class: `fi fi-${code} fi-size-${size}`, tag: 'span' }),
    },
    {
      name: /(brandico|entypo|fa|fontelico|glyphicon|iconicstroke|maki|openwebicons)-(.*)/,
      resolveFromRegex: (font, code) => ({ class: `${font} ${font}-${code}` }),
    },
    {
      name: 'material-icons-{code}',
      resolve: ({ code }) => ({ to: code }),
    },
    {
      name: 'mso-{content}',
      class: 'material-symbols-outlined',
      resolve: ({ content }) => ({ content: content }),
    },
    {
      name: 'custom-{code}',
      resolve: ({ code }) => ({
        component: customIcons[`custom-${code}`],
      }),
    },
  ],
})
